import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_tags_selector_filled = _resolveComponent("oss-tags-selector-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_reset = _resolveComponent("v-btn-reset")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      (_ctx.displayTypeInput && !_ctx.$vuetify.display.mobile)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "3",
            class: "px-2 pr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.type_,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type_) = $event)),
                items: _ctx.typesListResolve,
                disabled: _ctx.disabled,
                label: "Filtrer par type",
                "item-filter": "filter",
                "data-cy": "osserFilterBar-type",
                variant: "solo",
                density: "compact",
                "item-title": (item) => item.text
              }, null, 8, ["modelValue", "items", "disabled", "item-title"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_col, {
        cols: !(_ctx.displayTypeInput && !_ctx.$vuetify.display.xs) ? '12' : '9'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.text_,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.text_) = $event)),
            disabled: _ctx.disabled,
            "hide-details": "",
            block: "",
            label: "Recherche",
            type: "text",
            density: "compact",
            class: _normalizeClass(_ctx.fieldClass),
            "data-cy": "ossFilterBar-search",
            clearable: ""
          }, {
            "append-inner": _withCtx(() => [
              _createVNode(_component_v_menu, {
                modelValue: _ctx.menu,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.menu) = $event)),
                "close-on-content-click": false,
                "offset-y": "",
                left: "",
                bottom: "",
                elevation: "1"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn_icon, _mergeProps({
                    elevation: "0",
                    icon: "$tune",
                    size: "small",
                    style: {"margin-top":"-2px"}
                  }, props, { "data-cy": "ossFilterBar-dialog" }), null, 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: _normalizeClass({ 'pa-3 pb-0': true, 'mt-3': _ctx.$vuetify.display.mobile }),
                    elevation: "1",
                    style: _normalizeStyle({ width: !_ctx.$vuetify.display.mobile ? '700px' : undefined })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window, {
                        modelValue: _ctx.wizardStepSelectCompany,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.wizardStepSelectCompany) = $event)),
                        touchless: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_window_item, { value: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                                      _createElementVNode("h3", null, "Filtres", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.displayTypeInput)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1'),
                                        "data-cy": "ossFilterBar-type"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select_filled, {
                                            modelValue: _ctx.type_,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type_) = $event)),
                                            outlined: "",
                                            items: _ctx.typesListResolve,
                                            label: "Filtrer par type",
                                            "item-filter": "filter",
                                            "hide-details": true,
                                            disabled: _ctx.disabled,
                                            "data-cy": "ossFilterBar-type",
                                            density: "compact",
                                            "item-title": (item) => item.text
                                          }, null, 8, ["modelValue", "items", "disabled", "item-title"])
                                        ]),
                                        _: 1
                                      }, 8, ["cols", "class"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.displayStatusInput)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select_filled, {
                                            outlined: "",
                                            modelValue: _ctx.status_,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status_) = $event)),
                                            items: _ctx.statusListResolve,
                                            label: "Filtrer par statut",
                                            "item-filter": "filter",
                                            "hide-details": true,
                                            disabled: _ctx.disabled,
                                            "data-cy": "ossFilterBar-status",
                                            density: "compact",
                                            "item-title": "text"
                                          }, null, 8, ["modelValue", "items", "disabled"])
                                        ]),
                                        _: 1
                                      }, 8, ["cols", "class"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.displayThirdPartyCompanyInput)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 2,
                                        cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field_filled, {
                                            outlined: "",
                                            label: "Filtrer par société",
                                            "hide-details": true,
                                            disabled: 
                                                    _ctx.disabled ||
                                                    (_ctx.type_ !== 'SALES_INVOICE' &&
                                                        _ctx.type_ !== 'PURCHASE_INVOICE' &&
                                                        _ctx.type_ !== 'MAIL')
                                                ,
                                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.selectCompanyPanel()), ["stop"])),
                                            readonly: "",
                                            "model-value": _ctx.tpCompanyName,
                                            density: "compact"
                                          }, null, 8, ["disabled", "model-value"])
                                        ]),
                                        _: 1
                                      }, 8, ["cols", "class"]))
                                    : (_ctx.auditChecks)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 3,
                                          cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                          class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_select_filled, {
                                              outlined: "",
                                              modelValue: _ctx.auditCheck_,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.auditCheck_) = $event)),
                                              items: _ctx.auditChecks,
                                              label: "Contrôles",
                                              "item-filter": "filter",
                                              "hide-details": true,
                                              disabled: _ctx.disabled,
                                              density: "compact",
                                              "item-title": (item) => item.text,
                                              "data-cy": "OssFilterBar-AuditCheckSelect-Select"
                                            }, null, 8, ["modelValue", "items", "disabled", "item-title"])
                                          ]),
                                          _: 1
                                        }, 8, ["cols", "class"]))
                                      : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              (
                                            _ctx.displayTagsInput ||
                                            (_ctx.displayThirdPartyCompanyInput && _ctx.auditChecks)
                                        )
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 0,
                                    "no-gutters": "",
                                    class: _normalizeClass(_ctx.$vuetify.display.mobile ? '' : 'py-2')
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.displayTagsInput)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "4",
                                            class: "px-1"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_oss_tags_selector_filled, {
                                                modelValue: _ctx.tags_,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tags_) = $event)),
                                                items: _ctx.usedTags,
                                                label: 'Filtrer par étiquettes',
                                                disabled: _ctx.disabled,
                                                prefixDataCy: "OssFilterBar-etiquettes",
                                                "item-title": "text"
                                              }, null, 8, ["modelValue", "items", "disabled"])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.displayThirdPartyCompanyInput && _ctx.auditChecks)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 1,
                                            cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                            class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select_filled, {
                                                outlined: "",
                                                modelValue: _ctx.auditCheck_,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.auditCheck_) = $event)),
                                                items: _ctx.auditChecks,
                                                label: "Contrôles",
                                                "item-filter": "filter",
                                                "hide-details": true,
                                                disabled: _ctx.disabled,
                                                density: "compact",
                                                "item-title": (item) => item.text
                                              }, null, 8, ["modelValue", "items", "disabled", "item-title"])
                                            ]),
                                            _: 1
                                          }, 8, ["cols", "class"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.partitionTags)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 2,
                                            cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                            class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select_filled, {
                                                outlined: "",
                                                modelValue: _ctx.partitionTagId_,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.partitionTagId_) = $event)),
                                                items: _ctx.partitionTags,
                                                "item-value": "id",
                                                label: "Sans partition",
                                                "item-filter": "filter",
                                                "hide-details": true,
                                                disabled: _ctx.disabled,
                                                density: "compact",
                                                "item-title": (item) => item.name
                                              }, null, 8, ["modelValue", "items", "disabled", "item-title"])
                                            ]),
                                            _: 1
                                          }, 8, ["cols", "class"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.displayStatusInput && !_ctx.displayTagsInput)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 3,
                                            cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                                            class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select_filled, {
                                                outlined: "",
                                                modelValue: _ctx.declaredStatus_,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.declaredStatus_) = $event)),
                                                items: _ctx.declaredStatusListResolve,
                                                label: "Déclaré / Non Déclaré",
                                                "item-filter": "filter",
                                                "hide-details": true,
                                                disabled: _ctx.disabled,
                                                density: "compact",
                                                "item-title": "text"
                                              }, null, 8, ["modelValue", "items", "disabled"])
                                            ]),
                                            _: 1
                                          }, 8, ["cols", "class"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: _normalizeClass(_ctx.$vuetify.display.mobile ? '' : 'py-2')
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.displayStatusInput && _ctx.displayTagsInput)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: 
                                                _ctx.$vuetify.display.mobile
                                                    ? '12'
                                                    : _ctx.displaySwitchGraph
                                                      ? '3'
                                                      : '4'
                                            ,
                                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select_filled, {
                                            outlined: "",
                                            modelValue: _ctx.declaredStatus_,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.declaredStatus_) = $event)),
                                            items: _ctx.declaredStatusListResolve,
                                            label: "Déclaré / Non Déclaré",
                                            "item-filter": "filter",
                                            "hide-details": true,
                                            disabled: _ctx.disabled,
                                            density: "compact",
                                            "item-title": "text"
                                          }, null, 8, ["modelValue", "items", "disabled"])
                                        ]),
                                        _: 1
                                      }, 8, ["cols", "class"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.displayDateRange)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        cols: 
                                                _ctx.$vuetify.display.mobile
                                                    ? '6'
                                                    : _ctx.displaySwitchGraph
                                                      ? '3'
                                                      : '4'
                                            ,
                                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_oss_date_picker_filled, {
                                            modelValue: _ctx.startDate_,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.startDate_) = $event)),
                                            label: "Date de début",
                                            "hide-details": "",
                                            textFieldReadOnly: false,
                                            minDate: _ctx.minDate,
                                            disabled: _ctx.disabled
                                          }, null, 8, ["modelValue", "minDate", "disabled"])
                                        ]),
                                        _: 1
                                      }, 8, ["cols", "class"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.displayDateRange)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 2,
                                        cols: 
                                                _ctx.$vuetify.display.mobile
                                                    ? '6'
                                                    : _ctx.displaySwitchGraph
                                                      ? '3'
                                                      : '4'
                                            ,
                                        class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'px-1')
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_oss_date_picker_filled, {
                                            modelValue: _ctx.endDate_,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.endDate_) = $event)),
                                            label: "Date de fin",
                                            "hide-details": "",
                                            textFieldReadOnly: false,
                                            maxDate: _ctx.maxDate,
                                            disabled: _ctx.disabled
                                          }, null, 8, ["modelValue", "maxDate", "disabled"])
                                        ]),
                                        _: 1
                                      }, 8, ["cols", "class"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      (_ctx.displaySwitchGraph)
                                        ? (_openBlock(), _createBlock(_component_v_switch, {
                                            key: 0,
                                            class: "ml-4 mt-0 pt-0",
                                            modelValue: _ctx.displayGraph_,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.displayGraph_) = $event)),
                                            label: 
                                                    _ctx.startDate_ && _ctx.endDate_
                                                        ? 'Afficher le graphique des flux bancaires'
                                                        : 'Sélectionnez une période pour afficher le graphique des flux bancaires'
                                                ,
                                            "hide-details": "",
                                            disabled: !_ctx.startDate_ || !_ctx.endDate_
                                          }, null, 8, ["modelValue", "label", "disabled"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              (_ctx.type_ !== 'MAIL')
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 1,
                                    "no-gutters": "",
                                    class: _normalizeClass(_ctx.$vuetify.display.mobile ? '' : 'py-2')
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.displayMinAmount || _ctx.displayMaxAmount)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            md: "5",
                                            cols: "12",
                                            class: "px-1"
                                          }, {
                                            default: _withCtx(() => [
                                              (_ctx.filterWithTolerance)
                                                ? (_openBlock(), _createBlock(_component_v_row, {
                                                    key: 0,
                                                    "no-gutters": ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { cols: "6" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_text_field_filled, {
                                                            modelValue: _ctx.amountForTolerance,
                                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.amountForTolerance) = $event)),
                                                            label: `Montant`,
                                                            outlined: "",
                                                            dense: "",
                                                            "true-input": true,
                                                            "hide-details": "",
                                                            suffix: "€",
                                                            "data-cy": "ossFilterBar-minAmount",
                                                            disabled: _ctx.disabled
                                                          }, null, 8, ["modelValue", "disabled"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, { cols: "6" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_oss_text_field_filled, {
                                                            modelValue: _ctx.tolerance,
                                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tolerance) = $event)),
                                                            label: `Tolérance`,
                                                            outlined: "",
                                                            dense: "",
                                                            "true-input": true,
                                                            "hide-details": "",
                                                            suffix: "€",
                                                            "data-cy": "ossFilterBar-minAmount",
                                                            disabled: _ctx.disabled
                                                          }, null, 8, ["modelValue", "disabled"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_v_row, {
                                                    key: 1,
                                                    "no-gutters": "",
                                                    style: {"background-color":"#ececec","border-radius":"15px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.displayMinAmount)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 0,
                                                            class: "py-0"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_oss_text_field_filled, {
                                                                modelValue: _ctx.minPrice_,
                                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.minPrice_) = $event)),
                                                                label: `Min ${
                                                            _ctx.limitMinPrice
                                                                ? '(' +
                                                                  _ctx.newCommonFormatCurrency(
                                                                      _ctx.limitMinPrice,
                                                                      undefined,
                                                                  ) +
                                                                  ')'
                                                                : ''
                                                        }`,
                                                                outlined: "",
                                                                dense: "",
                                                                "true-input": true,
                                                                "hide-details": "",
                                                                suffix: "€",
                                                                "data-cy": "ossFilterBar-minAmount",
                                                                disabled: _ctx.disabled
                                                              }, null, 8, ["modelValue", "label", "disabled"])
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.displayMinAmount && _ctx.displayMaxAmount)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 1,
                                                            cols: "1",
                                                            class: "py-0 d-flex align-center justify-center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_icon, null, {
                                                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                                  _createTextVNode("$chevron-left")
                                                                ])),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      _createVNode(_component_v_col, { class: "py-0" }, {
                                                        default: _withCtx(() => [
                                                          (_ctx.displayMaxAmount)
                                                            ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                                key: 0,
                                                                modelValue: _ctx.maxPrice_,
                                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.maxPrice_) = $event)),
                                                                label: `Max ${
                                                            _ctx.limitMaxPrice
                                                                ? '(' +
                                                                  _ctx.newCommonFormatCurrency(
                                                                      _ctx.limitMaxPrice,
                                                                      undefined,
                                                                  ) +
                                                                  ')'
                                                                : ''
                                                        }`,
                                                                outlined: "",
                                                                dense: "",
                                                                "true-input": true,
                                                                "hide-details": "",
                                                                suffix: "€",
                                                                "data-cy": "ossFilterBar-maxAmount",
                                                                disabled: _ctx.disabled
                                                              }, null, 8, ["modelValue", "label", "disabled"]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        md: "3",
                                        class: "px-1 d-flex align-center justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_switch, {
                                            modelValue: _ctx.filterWithTolerance,
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filterWithTolerance) = $event)),
                                            class: "mt-0 pt-0 pl-2",
                                            "hide-details": ""
                                          }, {
                                            label: _withCtx(() => _cache[31] || (_cache[31] = [
                                              _createElementVNode("span", { class: "caption" }, " Filtrer avec tolérance ", -1)
                                            ])),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.payByList && _ctx.payByList.length)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 1,
                                            md: "4",
                                            cols: "6",
                                            class: "px-1"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select_filled, {
                                                modelValue: _ctx.payBy_,
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.payBy_) = $event)),
                                                items: _ctx.payByList,
                                                label: "Mode de paiement",
                                                outlined: "",
                                                "hide-details": "",
                                                disabled: _ctx.disabled,
                                                density: "compact",
                                                "item-title": "text"
                                              }, null, 8, ["modelValue", "items", "disabled"])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_icon, {
                                        icon: "",
                                        size: "small",
                                        onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.wizardStepSelectCompany = 0), ["stop"]))
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.companyId)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CompaniesTable, {
                                            showGenericCompany: false,
                                            showConsumerCompany: _ctx.type_ === 'SALES_INVOICE',
                                            showCustomerCompanies: 
                                                    _ctx.type_ === 'SALES_INVOICE' || _ctx.type_ === 'MAIL'
                                                ,
                                            showSupplierCompanies: 
                                                    _ctx.type_ === 'PURCHASE_INVOICE' || _ctx.type_ === 'MAIL'
                                                ,
                                            showExistingCompanies: false,
                                            showNewCompanies: false,
                                            company: 
                                                    _ctx.thirdPartyCompanyName_
                                                        ? _ctx.thirdPartyCompanyName_
                                                        : ''
                                                ,
                                            parentCompanyId: _ctx.companyId,
                                            wizardMode: true,
                                            onSelectCompany: _ctx.companySelected
                                          }, null, 8, ["showConsumerCompany", "showCustomerCompanies", "showSupplierCompanies", "company", "parentCompanyId", "onSelectCompany"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_card_actions, { class: "d-flex justify-space-between" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_reset, {
                            onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.clearMenu()), ["stop"])),
                            "data-cy": "ossFilterBar-resetFilter",
                            size: "small"
                          }),
                          _createVNode(_component_v_btn, {
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.menu = false)),
                            "data-cy": "ossFilterBar-validate",
                            size: "small",
                            variant: "tonal"
                          }, {
                            default: _withCtx(() => _cache[32] || (_cache[32] = [
                              _createTextVNode(" Valider ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class", "style"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled", "class"])
        ]),
        _: 1
      }, 8, ["cols"]),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_chip_group, null, {
            default: _withCtx(() => [
              (_ctx.dbStartDate && _ctx.dbEndDate && !_ctx.selectedAccountingClosing && !_ctx.auditCheck_)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    class: "ma-2",
                    color: "primary",
                    label: "",
                    size: "small",
                    variant: "flat",
                    ripple: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        location: "start"
                      }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createTextVNode("$oss-calendar")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" Du " + _toDisplayString(_ctx.formatDate(_ctx.dbStartDate)) + " au " + _toDisplayString(_ctx.formatDate(_ctx.dbEndDate)) + " ", 1),
                      (!_ctx.dateIsManadatory)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            right: "",
                            size: "small",
                            onClick: _ctx.removeDateFilter
                          }, {
                            default: _withCtx(() => _cache[34] || (_cache[34] = [
                              _createTextVNode("$close")
                            ])),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : (_ctx.dbStartDate && !_ctx.selectedAccountingClosing && !_ctx.auditCheck_)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 1,
                      size: "small",
                      class: "ma-2",
                      color: "primary",
                      label: "",
                      variant: "flat",
                      ripple: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          left: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[35] || (_cache[35] = [
                            _createTextVNode("$oss-calendar")
                          ])),
                          _: 1
                        }),
                        _createTextVNode(" À partir du " + _toDisplayString(_ctx.formatDate(_ctx.dbStartDate)) + " ", 1),
                        (!_ctx.dateIsManadatory)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              right: "",
                              size: "small",
                              onClick: _ctx.removeDateFilter
                            }, {
                              default: _withCtx(() => _cache[36] || (_cache[36] = [
                                _createTextVNode("$close")
                              ])),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : (_ctx.endDate_ && !_ctx.selectedAccountingClosing && !_ctx.auditCheck_)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 2,
                        class: "ma-2",
                        color: "primary",
                        label: "",
                        size: "small",
                        variant: "flat",
                        ripple: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            location: "start"
                          }, {
                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                              _createTextVNode("$oss-calendar")
                            ])),
                            _: 1
                          }),
                          _createTextVNode(" Jusqu'au " + _toDisplayString(_ctx.formatDate(_ctx.dbEndDate)) + " ", 1),
                          (!_ctx.dateIsManadatory)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                right: "",
                                size: "small",
                                onClick: _ctx.removeDateFilter
                              }, {
                                default: _withCtx(() => _cache[38] || (_cache[38] = [
                                  _createTextVNode("$close")
                                ])),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : (!!_ctx.selectedAccountingClosing)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 3,
                          class: "ma-2",
                          color: "primary",
                          label: "",
                          size: "small",
                          variant: "flat",
                          ripple: false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.selectedAccountingClosing.name), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
              (_ctx.showTypeTag && _ctx.displayTypeInput && _ctx.type_ !== 'ALL')
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 4,
                    size: "small",
                    class: "ma-2",
                    color: "primary",
                    label: "",
                    variant: "flat",
                    ripple: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        left: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[39] || (_cache[39] = [
                          _createTextVNode("$label")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("filter.type." + _ctx.type_.split("#")[0])) + " ", 1),
                      (!_ctx.typeIsManadatory)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            right: "",
                            size: "small",
                            onClick: _withModifiers(_ctx.removeType, ["stop"])
                          }, {
                            default: _withCtx(() => _cache[40] || (_cache[40] = [
                              _createTextVNode("$close")
                            ])),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showStatusTag && _ctx.displayStatusInput && _ctx.status_ !== 'ALL')
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 5,
                    class: "ma-2",
                    color: "primary",
                    label: "",
                    size: "small",
                    variant: "flat",
                    ripple: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        location: "start"
                      }, {
                        default: _withCtx(() => _cache[41] || (_cache[41] = [
                          _createTextVNode("$label")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.statusWording) + " ", 1),
                      (!_ctx.statusIsManadatory)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            right: "",
                            size: "small",
                            onClick: _withModifiers(_ctx.removeStatus, ["stop"])
                          }, {
                            default: _withCtx(() => _cache[42] || (_cache[42] = [
                              _createTextVNode("$close")
                            ])),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.displayDeclaredStatusInput && _ctx.declaredStatus_ !== 'ALL')
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 6,
                    class: "ma-2",
                    color: "primary",
                    label: "",
                    size: "small",
                    variant: "outlined"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        location: "start"
                      }, {
                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createTextVNode("$label")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.declaredStatusWording) + " ", 1),
                      _createVNode(_component_v_icon, {
                        right: "",
                        size: "small",
                        onClick: _withModifiers(_ctx.removeDeclaredStatus, ["stop"])
                      }, {
                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                          _createTextVNode("$close")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.tpCompanyName)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 7,
                    size: "small",
                    class: "ma-2",
                    color: "primary",
                    label: "",
                    variant: "flat",
                    ripple: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        left: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                          _createTextVNode("$fa-building")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.tpCompanyName) + " ", 1),
                      _createVNode(_component_v_icon, {
                        right: "",
                        size: "small",
                        onClick: _ctx.removeCompany
                      }, {
                        default: _withCtx(() => _cache[46] || (_cache[46] = [
                          _createTextVNode("$close")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.auditCheck_)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 8,
                    size: "small",
                    class: "ma-2",
                    color: "primary",
                    label: "",
                    variant: "flat",
                    ripple: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        left: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[47] || (_cache[47] = [
                          _createTextVNode("$fa-check")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("audit." + _ctx.auditCheck_ + ".mainTitle")) + " ", 1),
                      _createVNode(_component_v_icon, {
                        right: "",
                        size: "small",
                        onClick: _ctx.removeAuditCheck
                      }, {
                        default: _withCtx(() => _cache[48] || (_cache[48] = [
                          _createTextVNode("$close")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.partitionTagId_ !== '')
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 9,
                    size: "small",
                    class: "ma-2",
                    color: "primary",
                    label: "",
                    variant: "flat",
                    ripple: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        left: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[49] || (_cache[49] = [
                          _createTextVNode("$fa-check")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.partitionTagTitle) + " ", 1),
                      _createVNode(_component_v_icon, {
                        right: "",
                        size: "small",
                        onClick: _ctx.removePartitionTag
                      }, {
                        default: _withCtx(() => _cache[50] || (_cache[50] = [
                          _createTextVNode("$close")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
                        _ctx.minPrice_ &&
                        _ctx.minPrice_ !== _ctx.limitMinPrice &&
                        _ctx.maxPrice_ &&
                        _ctx.maxPrice_ !== _ctx.limitMaxPrice
                    )
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 10,
                    size: "small",
                    class: "ma-2",
                    color: "primary",
                    label: "",
                    variant: "flat",
                    ripple: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        left: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[51] || (_cache[51] = [
                          _createTextVNode("$fa-money-bill-wave")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" Entre " + _toDisplayString(_ctx.minPrice_) + "€ et " + _toDisplayString(_ctx.maxPrice_) + "€ ", 1),
                      _createVNode(_component_v_icon, {
                        right: "",
                        size: "small",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.removePrice()))
                      }, {
                        default: _withCtx(() => _cache[52] || (_cache[52] = [
                          _createTextVNode("$close")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_ctx.minPrice_ && _ctx.minPrice_ !== _ctx.limitMinPrice)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 11,
                      size: "small",
                      class: "ma-2",
                      color: "primary",
                      label: "",
                      variant: "flat",
                      ripple: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          left: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[53] || (_cache[53] = [
                            _createTextVNode("$fa-money-bill-wave")
                          ])),
                          _: 1
                        }),
                        _createTextVNode(" Plus de " + _toDisplayString(_ctx.minPrice_) + "€ ", 1),
                        _createVNode(_component_v_icon, {
                          right: "",
                          size: "small",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.removePrice()))
                        }, {
                          default: _withCtx(() => _cache[54] || (_cache[54] = [
                            _createTextVNode("$close")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_ctx.maxPrice_ && _ctx.maxPrice_ !== _ctx.limitMaxPrice)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 12,
                        size: "small",
                        class: "ma-2",
                        color: "primary",
                        label: "",
                        variant: "flat",
                        ripple: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            left: "",
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[55] || (_cache[55] = [
                              _createTextVNode("$fa-money-bill-wave")
                            ])),
                            _: 1
                          }),
                          _createTextVNode(" Moins de " + _toDisplayString(_ctx.maxPrice_) + "€ ", 1),
                          _createVNode(_component_v_icon, {
                            right: "",
                            size: "small",
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.removePrice()))
                          }, {
                            default: _withCtx(() => _cache[56] || (_cache[56] = [
                              _createTextVNode("$close")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
              (_ctx.tags_ && _ctx.tags_.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 13 }, _renderList(_ctx.tags_, (tag, index) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      key: index,
                      class: "ma-2",
                      color: tag ? `${tag.color}` : '',
                      outlined: tag && tag.type === 'SubAccountableAccount',
                      label: "",
                      size: "small",
                      ripple: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          left: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[57] || (_cache[57] = [
                            _createTextVNode("$label")
                          ])),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(tag ? tag.text : "XXX") + " ", 1),
                        _createVNode(_component_v_icon, {
                          right: "",
                          size: "small",
                          onClick: ($event: any) => (_ctx.removeTag(index))
                        }, {
                          default: _withCtx(() => _cache[58] || (_cache[58] = [
                            _createTextVNode("$close")
                          ])),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["color", "outlined"]))
                  }), 128))
                : _createCommentVNode("", true),
              (_ctx.payBy_ && _ctx.payBy_ !== 'ALL')
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 14,
                    class: "ma-2",
                    color: "primary",
                    outlined: true,
                    label: "",
                    size: "small",
                    ripple: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        left: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[59] || (_cache[59] = [
                          _createTextVNode("$label")
                        ])),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(`zTillReceipt.transaction.${_ctx.payBy_}`)) + " ", 1),
                      _createVNode(_component_v_icon, {
                        right: "",
                        size: "small",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.payBy_ = 'ALL'))
                      }, {
                        default: _withCtx(() => _cache[60] || (_cache[60] = [
                          _createTextVNode("$close")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}